import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Alert } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import RecurringStats from './RecurringDonations/RecurringStats';
import RecurringSubscriptionsTable from './RecurringDonations/RecurringSubscriptionsTable';
import UnsubscribeRequestsTable from './RecurringDonations/UnsubscribeRequestsTable';
import PageLoader from '../../../Reusable/PageLoader';
import baseURL from '../config';

const RecurringDonations = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [unsubRequests, setUnsubRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [subsRes, reqsRes] = await Promise.all([
                    fetch(`${baseURL}/admin/recurring-subscriptions`, { credentials: 'include' }),
                    fetch(`${baseURL}/admin/unsubscribe-requests`, { credentials: 'include' }),
                ]);

                if (!subsRes.ok) throw new Error('Failed to fetch recurring subscriptions.');
                if (!reqsRes.ok) throw new Error('Failed to fetch unsubscribe requests.');

                const subsData = await subsRes.json();
                const reqsData = await reqsRes.json();

                setSubscriptions(subsData);
                setUnsubRequests(reqsData);
            } catch (err) {
                setError(err.message || 'An unexpected error occurred.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const stats = {
        total_active: subscriptions.filter(s => s.status === 'active').length,
        total_cancelled: subscriptions.filter(s => s.status === 'cancelled').length,
        total_failed: subscriptions.filter(s => s.status === 'failed').length,
        total_donations: subscriptions.reduce((sum, s) => sum + (Number(s.total_donations) || 0), 0),
    };

    if (loading) {
        return (
            <DashboardLayout>
                <PageLoader message="Loading recurring donations..." />
            </DashboardLayout>
        );
    }

    if (error) {
        return (
            <DashboardLayout>
                <Box sx={{ p: 3 }}>
                    <Alert severity="error">{error}</Alert>
                </Box>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <RecurringStats stats={stats} />
            <RecurringSubscriptionsTable subscriptions={subscriptions} />
            <UnsubscribeRequestsTable requests={unsubRequests} setRequests={setUnsubRequests} />
        </DashboardLayout>
    );
};

export default RecurringDonations;
